interface Props {
  title: string;
  description?: string;
  children?: React.ReactNode;
}

export function PageHeader ({title, description, children}: Props) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      {children}
    </div>
  );
}